import { Link } from "react-router-dom";
import type { DashboardSummary, SyncStatus } from "@silph-scope/shared";
import { useDashboards } from "../api/hooks";

const STATUS_LABEL: Record<SyncStatus, string> = {
  fresh: "Live",
  aging: "Aging",
  stale: "Stale",
  failed: "Sync failed",
  unavailable: "Coming soon"
};
const STATUS_CLASS: Record<SyncStatus, "ok" | "bad"> = {
  fresh: "ok",
  aging: "ok",
  stale: "bad",
  failed: "bad",
  unavailable: "bad"
};

export function CatalogPage() {
  const { data: dashboards, isLoading } = useDashboards();

  return (
    <div className="catalog-page">
      <div className="catalog-head">
        <div>
          <h1>Dashboards</h1>
          <p>{dashboards?.length ?? 0} supported · synced from Asana</p>
        </div>
      </div>
      {isLoading ? (
        <p>Loading…</p>
      ) : (
        <div className="catalog-grid">
          {(dashboards ?? []).map((d) => (
            <CatalogCard key={d.id} dashboard={d} />
          ))}
        </div>
      )}
    </div>
  );
}

function CatalogCard({ dashboard }: { dashboard: DashboardSummary }) {
  const content = (
    <>
      <div className="catalog-card-top">
        <span className="catalog-icon-chip">
          <i className={dashboard.icon} />
        </span>
        <span className={`pill ${STATUS_CLASS[dashboard.status]}`}>{STATUS_LABEL[dashboard.status]}</span>
      </div>
      <div className="catalog-card-body">
        <span className="catalog-card-name">{dashboard.name}</span>
        <span className="catalog-card-desc">{dashboard.description}</span>
      </div>
      <div className="catalog-card-footer">
        <span>
          {dashboard.panelCount} panels · {dashboard.refreshInterval}
        </span>
        <i className="ri-arrow-right-up-line" />
      </div>
    </>
  );

  if (!dashboard.implemented) {
    return <div className="card catalog-card disabled">{content}</div>;
  }
  return (
    <Link to={`/d/${dashboard.id}`} className="card catalog-card">
      {content}
    </Link>
  );
}
